/**
 * Extract a user-friendly error message from ky errors or generic exceptions.
 * Handles HTTPError (with status-specific messages), TimeoutError,
 * network/fetch failures, and unknown errors.
 */
export async function getErrorMessage(error: any): Promise<string> {
  if (error?.name === 'TimeoutError') {
    return 'Request timed out. Please try again.';
  }

  if (error?.name === 'HTTPError') {
    const status = error.response?.status;
    if (status === 401 || status === 403) {
      return 'Not authorized. Please refresh and try again.';
    }
    if (status === 400) {
      try {
        const body = await error.response.json();
        return body?.error || 'Invalid request.';
      } catch {
        return 'Invalid request.';
      }
    }
    if (status >= 500) {
      return 'Server error. Please try again later.';
    }
  }

  if (error?.message?.includes('fetch')) {
    return 'Connection lost. Please check your network.';
  }

  return 'Something went wrong. Please try again.';
}
